import assets from 'modules/assets'
import * as parse from 'modules/parse'

export function intro(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          content: ['Gakko Camps']
        }
      ],
      [
        {
          type: 'p',
          content: data['camps-paragraph-1']
        },
        {
          type: 'p',
          content: data['camps-paragraph-2']
        }
      ],
      [
        {
          type: 'p',
          content: data['camps-paragraph-3']
        },
        {
          type: 'p',
          content: ' ' // A unicode en-space, in order to get this paragraph act like a break.
        },
        {
          type: 'h5',
          // style: 'large',
          content: 'Interested in getting involved?'
        },
        {
          type: 'p',
          // style: 'large',
          content: 'Read more about coming to Gakko as a student and apply to be a sempai below.'
        },
        {
          type: 'p',
          content: 'Join the mailing list for more information on 2018 programming and partnerships.',
          hasMarginTop: false,
          linkURL: 'https://gakkoproject.us4.list-manage.com/subscribe/post?u=fa4319fecd8b40e74b6a3ee7b&id=477d0e625d',
          outbound: true
        }
      ]
    ]
  }
}


// export function intro(data) {
//   // Feeds into LargeQuote
//   return {
//     title: 'The Gakko Camp Project',
//     subTitle: {
//       text: '',
//       editStyle: true
//     },
//     quote1: {
//       text: '...an interval, // [...] // an instant // of pure // potentiality',
//       editStyle: true,
//       words: ['instant'],
//       style: 'sectra'
//     },
//     quote2: {
//       text: 'when everything, as it were, trembles // in the balance.',
//       editStyle: true,
//       words: ['trembles'], // editStyle on second element not supported
//       style: 'sectra'
//     },
//     author: 'From Ritual To Theater',
//     source: 'Victor Turner'  // source is not supported yet
//   }
// }

// export function intro2(data) {
//   // Feeds into LargeQuote
//   return {
//     content: [
//       [],
//       [
//         {
//           type: 'p',
//           // style: 'large',
//           content: 'Join the mailing list to stay up to date on application deadlines, 2018 program announcements and more.'
//         }
//       ],
//       [
//         {
//           type: 'p',
//           content: '',
//           button: {
//             content: 'Subscribe to our mailing list',
//             outbound: true,
//             linkURL: 'https://gakkoproject.us4.list-manage.com/subscribe/post?u=fa4319fecd8b40e74b6a3ee7b&id=477d0e625d'
//           }
//         }
//       ],
//     ]
//   }
// }

// export function manifesto(data) {
//   // Feeds into RowThreeText
//   return {
//     content: [
//       [
//         {
//           type: 'h3',
//           content: ['Manifesto']
//         }
//       ],
//       [
//         {
//           type: 'p',
//           content: data['camps-paragraph-1']
//         },
//         {
//           type: 'p',
//           content: data['camps-paragraph-2']
//         }
//       ],
//       [
//         {
//           type: 'p',
//           content: data['camps-paragraph-3']
//         }
//       ]
//     ]
//   }
// }

export function links(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          content: ['Get Involved']
        }
      ],
      [
        {
          type: 'h3',
          content: ['Sempai 先輩'],
          noMarginBottom: true
        },
        {
          type: 'ol',
          definition: 'noun.',
          style: ['medium-large', 'two-thirds', 'no-min-height'],
          content: ['People who were born before you.', 'The college students & young professionals who create and facilitate each camp.']
          // button: {
          //   content: 'Learn about the sempai program',
          //   linkURL: '/sempai'
          // }
        },
        {
          type: 'p',
          content: 'Every summer, Gakko assembles teams of eight sempai to collaboratively build a camp from scratch through the design of educational workshops, projects, performances, camp rituals and a compelling two/three-week camp narrative. Sempai are selected for demonstrated rigor in a diversity of disciplines and generosity in their interactions with others. They are curious about camp as a medium for experiential learning and authentic personal development of an international group of high school students.'
        },
        {
          type: 'h5',
          content: 'Sempai applications close January 11, 2018.'
        },
        {
          type: 'p',
          content: '',
          hasMarginTop: true,
          button: {
            content: 'Apply now!',
            outbound: true,
            linkURL: 'https://gakko.smapply.io/prog/gakko_camps_sempai_application/'
          }
        }
      ],
      [
        {
          type: 'h3',
          content: ['Kohai 後輩'],
          noMarginBottom: true
        },
        {
          type: 'ol',
          definition: 'noun.',
          style: ['medium-large', 'two-thirds', 'no-min-height'],
          content: ['People who were born after you.', 'The high school students who attend camp, in search of "something more"']
          // button: {
          //   content: 'Learn about the kohai experience',
          //   linkURL: '/kohai'
          // },
          // button2: {
          //   content: 'Nominate a high school student',
          //   outbound: true,
          //   linkURL: 'https://goo.gl/forms/QJFFw7uKsvtZBJZn1'
          // }
        },
        {
          type: 'p',
          content: 'Every summer, 45 kohai arrive at camps that have been designed uniquely for them. For two/three weeks, on location at a beautiful site, kohai engage in rigorous workshops, hands-on projects, and collaborations across disciplines. In a diverse community of friends and mentors, through meaningful international dialogue, kohai build and take ownership over an “undiscovered country”—a vibrant camp community that has never existed before.'
        },
        {
          type: 'h5',
          content: 'Kohai applications open January 2018.'
        },
        {
          type: 'p',
          content: '',
          hasMarginTop: true,
          button: {
            content: 'Learn more',
            linkURL: 'https://gakkoproject.us4.list-manage.com/subscribe/post?u=fa4319fecd8b40e74b6a3ee7b&id=477d0e625d',
            outbound: true
          }
        }
      ]
    ]
  }
}

export function links2(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
      ],
      [
        {
          type: 'p',
          content: '',
          hasMarginTop: false,
          button: {
            content: 'Apply now!',
            outbound: true,
            linkURL: 'https://gakko.smapply.io/prog/gakko_camps_sempai_application/'
          }
        }
      ],
      [
        {
          type: 'p',
          content: '',
          hasMarginTop: false,
          button: {
            content: 'Learn more',
            linkURL: 'https://gakkoproject.us4.list-manage.com/subscribe/post?u=fa4319fecd8b40e74b6a3ee7b&id=477d0e625d',
            outbound: true
          }
        }
      ]
    ]
  }
}

export function location(data) {
  // Feeds into RowFour
  return {
    background: 'white',
    title: {
      type: 'h3',
      content: ['Summer 2018']
    },
    content: [
      {
        imageURL: assets('images/locations/berkshires1.jpg'),
        title: 'The Berkshires, USA',
        subTitle: 'June 24–July 13',
        subSubTitle: '(3 weeks)',
        description: '',
        centeredText: true
      },
      {
        imageURL: assets('images/locations/okayama1.jpg'),
        title: 'Okayama, Japan',
        subTitle: 'July 1—14',
        subSubTitle: '(2 weeks)',
        description: '',
        centeredText: true
      },
      {
        imageURL: assets('images/locations/berkshires2.jpg'),
        title: 'The Berkshires, USA',
        subTitle: 'July 22—August 4',
        subSubTitle: '(2 weeks)',
        description: '',
        centeredText: true
      },
      {
        imageURL: assets('images/locations/okayama2.jpg'),
        title: 'Okayama, Japan',
        subTitle: 'July 27—August 9',
        subSubTitle: '(2 weeks)',
        description: '',
        centeredText: true
      }
    ]
  }
}

export function externalVideos() {
  // Feeds into RowThreeBlock
  return {
    title: '',
    content: [
      {
        linkURL: 'https://youtu.be/xwFDAlWNGv0',
        style: 'grid-small spotlight-link',
        title: 'Bali 2017: Moments from camp >>',
        subTitle: 'Learn more',
        firstRow: {
          type: 'img',
          imageURL: assets('images/spotlight/bali.jpg'),
          style: ''
        }
      },
      {
        linkURL: 'https://youtu.be/ch1DGli2DLk',
        style: 'grid-small grid-middle spotlight-link',
        title: 'France 2017: A deeper look at camp >>',
        subTitle: 'Learn more',
        firstRow: {
          type: 'img',
          imageURL: assets('images/spotlight/france.jpg'),
          style: ''
        }
      },
      {
        linkURL: 'https://youtu.be/CzLRE21igK0',
        style: 'grid-small spotlight-link',
        title: 'Sempai profile: Meet Artist Sam Schanwald >>',
        subTitle: 'Learn more',
        firstRow: {
          type: 'img',
          imageURL: assets('images/spotlight/sam.jpg'),
          style: ''
        }
      }
    ]
  }
}


export function team(data) {
  // Feeds into RowFour
  return {
    title: {
      type: 'h2',
      content: [data['team-title']]
    },
    content: [
      {
        imageURL: assets('images/team/kenta.jpg'),
        title: data['team-a-name'],
        subTitle: 'B.A. in Computer Science — Yale University, 2014',
        description: data['team-a-bio']
      },
      {
        imageURL: assets('images/team/natalie.jpg'),
        title: data['team-b-name'],
        subTitle: 'B.A. in American Studies — Yale University, 2014',
        description: data['team-b-bio']
      },
      {
        imageURL: assets('images/team/leyla.jpg'),
        title: data['team-c-name'],
        subTitle: 'B.A. in Architecture — Yale University, 2016',
        description: data['team-c-bio']
      },
      {
        imageURL: assets('images/team/dylan.jpg'),
        title: data['team-d-name'],
        subTitle: 'B.F.A., Theatuer — U. of Evansville, 2014; M.F.A., Acting — Yale University, 2017',
        description: data['team-d-bio']
      },
      {
        imageURL: assets('images/team/michael.jpg'),
        title: data['team-g-name'],
        subTitle: 'B.F.A. in Graphic Design — Academy of Art University, 2017',
        description: data['team-g-bio']
      },
      {
        imageURL: assets('images/team/zoe.jpg'),
        title: data['team-h-name'],
        subTitle: 'B.A. in Comparative Literature and Urban Studies — American University of Paris',
        description: data['team-h-bio']
      }
    ]
  }
}

export function faq(data) {
  return {
    title: 'Sempai FAQ',
    subTitle: '',
    english: '',
    japanese: '',
    definition: '',
    wordType: '',
    definition2: '',
    definition3: '',
    button: '',
    questions: [
      {
        question: 'What is the time commitment?',
        answer: '4-5 weeks depending on the program. This includes a two-week design process (10 days off-site and 5 days on location) and two-weeks of camp; the first Berkshires program is an exception with a three-week camp commitment. The sempai experience begins with a two-week design process lead by two camp directors. Directors for camp in Japan work with their team in Kyoto while camp teams in the USA work off-site in the beautiful Berkshires. The two-week intense design process includes testing workshop content and imagining the rituals, games, myths, vocabulary that will provide the foundation for the unique camp. Design culminates with a camp schedule, which teams then bring to life as they welcome students to their respective camp-sites (Okayama in Japan, Darrow School in the USA).'
      },
      {
        question: 'Do I need teaching experience? What type of class should I teach?',
        answer: 'Not at all. What we bring to the table is the design process that will help you draw out ideas and curate a set of learning experiences for the kohai. If you are passionate about your subject, and are willing to work with people across disciplines to experiment with different ways of sharing your gift, we want to work with you. Some highlights from the past include a workshop on cryptography focused on the world’s first human Enigma Machine (think kohai bodies as rotors and a volleyball as a signal), or a day on community design and architecture that culminated in building a full-scale bamboo structure. From socratic seminars on the nature of free will to slam poetry sessions in chemistry jargon, we’ve been lucky enough to work with a variety of experiential forms. We can’t wait to see what you will add to the mix!'
      },
      {
        question: 'How much will this cost me?',
        answer: 'Long story short, Gakko covers the essentials. We reimburse sempai for round-trip travel (including flights) from their residence to each program preparation location, and cover the cost of transportation to the final camp venue. Sempai receive free accommodation and meals during the two-weeks of program prep and throughout camp. Meals are catered at each location, and we do our best to accommodate dietary restrictions.'
      },
      {
        question: 'Should I apply to a specific camp?',
        answer: 'No. Though we will evaluate all applicants before assigning camp teams, we must consider applicants’ date or travel restrictions in admissions.'
      },
      {
        question: 'Tell us more about the high school students?',
        answer: 'Kohai, the high school students who participate in our camps, come from a diverse international pool of applicants, and various walks of life. Last year, 65 nationalities were represented amongst the class of 120 kohai. High school students are required to possess a participatory level of English for all workshops and enables them to travel independently to/from camp pickup location in the USA. In our application process, we look for curiosity, passion, and open-mindedness. You can see some of our past kohai’s testimonials in our video series “I Was a Kohai”.'
      }
    ]
  }
}

export function timeline(data) {
  // Feeds into Timeline
  return {
    title: {
      content: [
        [
          {
            type: 'h3',
            content: ['Timeline']
          }
        ]
      ]
    },
    content: [
      [
        {
          year: 2016,
          date: data['timeline-a'],
          title: data['timeline-a-title'],
          subTitle: data['timeline-a-sub']
        },
        {
          date: data['timeline-b'],
          title: data['timeline-b-title'],
          subTitle: data['timeline-b-sub']
        }
      ],
      [
        {
          year: 2017,
          date: data['timeline-c'],
          title: data['timeline-c-title'],
          subTitle: data['timeline-c-sub']
        },
        {
          date: data['timeline-d'],
          title: data['timeline-d-title'],
          subTitle: data['timeline-d-sub']
        }
      ],
      [
        {
          date: data['timeline-e'],
          title: data['timeline-e-title'],
          subTitle: data['timeline-e-sub']
        },
        {
          date: data['timeline-f'],
          title: data['timeline-f-title'],
          subTitle: data['timeline-f-sub']
        }
      ]
    ],
    contentLarge: [
      {
        date: data['timeline-g'],
        content: [
          {
            title: {
              content: data['timeline-g-title']
            },
            subTitle: {
              content: data['timeline-g-sub']
            }
          }
        ]
      },
      {
        date: data['timeline-h'],
        content: [
          {
            title: {
              content: data['timeline-h-title-a']
            },
            subTitle: {
              content: data['timeline-h-sub-a']
            }
          },
          {
            title: {
              content: data['timeline-h-title-b']
            },
            subTitle: {
              content: data['timeline-h-sub-b']
            }
          },
          {
            title: {
              content: data['timeline-h-title-c']
            },
            subTitle: {
              content: data['timeline-h-sub-c']
            }
          }
        ]
      },
      {
        date: data['timeline-i'],
        content: [
          {
            title: {
              content: data['timeline-i-title-a']
            },
            subTitle: {
              content: data['timeline-i-sub-a']
            }
          },
          {
            title: {
              content: data['timeline-i-title-b']
            },
            subTitle: {
              content: data['timeline-i-sub-b']
            }
          }
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/modules/camps.js